/// <reference path='../_all.ts' />

declare var requestFrame: IRequestFrame;

module navigation {
  'use strict';

  /**
   * Services that changes the url according to elements in viewport.
   * AnchorNavDirective adds Elements, and this Service changes the location path, according to the Element currently in the viewport.
   */
  export class ParallaxService implements IParallaxService {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$rootScope',
      '$window',
      '$timeout',
      '$q',
      'debounce',
    ];

    constructor(
      private $rootScope: ng.IRootScopeService,
      private $window: ng.IWindowService,
      private $timeout: ng.ITimeoutService,
      private $q: ng.IQService,
      private debounce: navigation.IDebounceService
    ) {

      var request = angular.bind($window, requestFrame('request'));
      
      var onScroll = (time : number) => {

        //limit to 60fps
        if (time < this.fPSTimeStamp) {
          request(angular.bind(this, onScroll));
          return;
        };

        var t = (time + this.fpsDelay);
        this.fPSTimeStamp = Math.round(t/this.fpsDelay) * this.fpsDelay;

        if (this.scrollTop == this.lastScrollTop) return; //no scrolling, no work;
        this.lastScrollTop = this.scrollTop; 

        //run handler        
        this.$rootScope.$emit('navigation-scroll', this.lastScrollTop);
        this.isTicking = false;        
      }
      this.onScroll = angular.bind(this, onScroll);

      //there are times where isTicking is not reset, this will reset is Ticking after a certain timout, trailing edge debounced.
      var debouncedResetOfIsTicking = debounce(()=> { this.isTicking = false; }, 1000, false);

      angular.element($window).bind("scroll", () => {
        this.scrollTop = $(this.$window).scrollTop();
        if (!this.isTicking) {
          request(this.onScroll);
          this.isTicking = true;
          debouncedResetOfIsTicking();
        }
      });

    }
    
    request :IRequestFrameFunction;

    isTicking : boolean = false;
    fPSTimeStamp : number = 0;
    fpsDelay = Math.round(1000 / 60); //60 fps;

    lastDocumentHeight : number = -1;
    scrollTop : number = -1;
    lastScrollTop : number = -1;

    onScroll : Function; 


    public subscribeOnScroll (
      scope : ng.IScope
      , callback: IParallaxServiceListener
      ) : void {
      var handler = this.$rootScope.$on('navigation-scroll', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    //for parallax time and change will be same, start = 0, duration = end
    public easeInOutQuad(time : number, start : number, change : number, duration : number, round? : boolean) : number {      
        time = Math.max(Math.min(time, duration), 0);
        if (!round) {
          return this.easeInOutQuadIntern(time, start, change, duration);
        } else {
          return Math.round(this.easeInOutQuadIntern(time, start, change, duration));
        }
        
    };


    //http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
    //http://gizma.com/easing/#quad3 / http://easings.net/#easeInOutQuad
    //http://upshots.org/actionscript/jsas-understanding-easing
    private easeInOutQuadIntern (t:number, b:number, c:number, d:number):number {
	    var ts:number=(t/=d)*t;
	    var tc:number=ts*t;
	    return b+c*(6*tc*ts + -15*ts*ts + 10*tc);
    }


  }
}